import http from '@/util/http';

export default {
	getEBType() {
		return http.get('EBillHome/api/getEBillType');
	},
	//email為空 => applySMS, notifyMdn為空 => applyMail, 都not null => applyMailSMS
	applyMailSMS(email, notifyMdn){
		let ftReq = {email: email, notifyMdn: notifyMdn}
		return http.post('EBillHome/api/applyMailSMS', ftReq);
	},
	changeEBillType(mdn, ebType, email, sms){
		let ftReq = {mdn: mdn, ebType: ebType, email: email, sms: sms}
		return http.post('EBillHome/api/changeEBillType',ftReq);
	},
}


// WEBPACK FOOTER //
// ./src/api/eBillHome/eBillHomeApi.js